import React, { useState } from 'react';
import styles from './_style.module.scss';

const SelectQuantity = ({ id, drawing, unit }) => {
  const [value, setValue] = useState(1000);

  return (
    <div className={styles.formGroup} data-widget-element="form-group">
      <label className={styles.label} data-widget-element="label">{t('quote_builder_widget.quantity')}</label>
      <div className={styles.inputWrapper} data-widget-element="input-wrapper">
        <input
          type="number"
          className={styles.input}
          data-widget-element="input"
          value={value}
          onChange={(e) => setValue(() => e.target.value)}
        />
      </div>
    </div>
  );
};

export default SelectQuantity;
